module.exports = __webpack_public_path__ + "img/pc-bg01.e7d4daac.png";